import { render } from "./BabyDiaryRegister.vue?vue&type=template&id=131bc5ae"
import script from "./BabyDiaryRegister.vue?vue&type=script&lang=js"
export * from "./BabyDiaryRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__